var exports = {
  "p": "list__Tgbn6n",
  "A": "item__EUTF7W",
};

module.exports = exports;
